export default {
    "title": "南方周末",
    "copyright": "Copyright©2008-2018 广东南方数媒工场科技有限责任公司",
    "empowerment": "",
    "footer": {
        "links": [
            { "id": 1, "title": "南周品牌", "path": "http://www.nfzmbrand.com/", "pathTo": "outlink" },
            { "id": 2, "title": "广告服务", "path": "http://www.infzm.com/yingxiao.shtml", "pathTo": "outlink" },
            { "id": 3, "title": "版权声明", "path": "/help/copyright", "pathTo": "vue-router" },
            { "id": 4, "title": "关于我们", "path": "/help/about", "pathTo": "vue-router" },
            { "id": 5, "title": "加入我们", "path": "http://www.infzm.com/topic/jobs.shtml", "pathTo": "outlink" },
            { "id": 6, "title": "APP下载", "path": "https://lkme.cc/iHD/0tpQValRK", "pathTo": "outlink" },
        ]
    },
    "banner": {
      "more": "相关推荐"
    },
    "shareInfo": {
        "title" : "维权315 | 南方周末喊你来爆料",
        "desc"  : "如果你想发声，请来我们的爆料平台爆料~",
        "link"  : window.location.href,
        "imgUrl": "http://images.infzm.com/medias/default/logo_100_white.png",
        "icon"  : "http://images.infzm.com/medias/default/logo_100_white.png"
    },
    "cdkeyNotice": [
        { "id": 1, "title": "会员卡仅限登录用户使用，输入激活码即可激活", "description": "" },
        { "id": 2, "title": "激活成功后立即成为南方周末会员，享受南方周末会员专属特权", "description": "" },
        { "id": 3, "title": "请在会员卡有效期内激活，过期失效，无法使用", "description": "" },
        { "id": 4, "title": "此卡严禁倒卖、转让，不可兑换现金，请妥善保管，若发生盗用、泄露、遗失等问题不补", "description": "" },
        { "id": 5, "title": "有特殊限制的会员卡，请按其说明进行使用", "description": "" },
    ],
    "memberships": [
        { "id": 1, "title": "即时畅读南方周末全媒体优质内容及经典名篇", "description": "享有会员期间同步上线的南方周末电子报阅读权限，篇篇原创，绝对深度重磅。在线阅读南方周末网站、APP所有内容（付费产品除外），及时获取南方周末倾力打造的网络独家原创报道。\n 三十多年独立视角、几代新闻人专业积累、数十万篇历史报道向会员敞开。" },
        { "id": 2, "title": "通览南方人物周刊等南周报系旗下其它品牌机构内容精粹", "description": "通览《南方人物周刊》精华内容，畅享南瓜视业优选精彩视频。" },
        { "id": 3, "title": "享受知识付费及文创产品专属优惠", "description": "优惠购买南周报系出品的知识付费产品、周MALL文创产品（敬请期待）等南周严选商品" },
        { "id": 4, "title": "优先参与南周报系精彩活动的VIP权益", "description": "免费申领或优惠购买南周报系各类精彩活动入场券，有机会现场享有VIP通道和席位（活动举办时间、入场券申领或优惠办法以正式通知为准）" },
        { "id": 5, "title": "无干扰阅读体验", "description": "可选择关闭APP广告显示，获得清爽无干扰阅读体验。" },
    ],
    "tickers": [
        { "id": "com.nfzm.week", "price": 3, "title": "按周订阅", "sub_title": '周会员', "disabled": true },
        { "id": "com.nfzm.year", "price": 98, "title": "按年订阅", "sub_title": '年会员', "disabled": false },
        { "id": "com.nfzm.month", "price": 15, "title": "按月订阅", "sub_title": '月会员', "disabled": false },
    ]
}
